/* eslint-disable @typescript-eslint/no-explicit-any */
import { jwtDecode } from 'jwt-decode';
import { JWTTokenDTO } from '../redux/identity/identityTypes';
import {
 deleteCookieCustom,
 getCookieCustom,
 setCookieCustom,
} from './cookies';
import {
 removeConfigStorageItem,
 setConfigStorageItem,
} from '../hooks/useConfigStorage';

const DEFAULT_ACCESS_EXPIRATION_MINUTES = 100;
const DEFAULT_REFRESH_EXPIRATION_MINUTES = 100 * 24 * 7;

const getAccessExpirationMinutes = (tokenData: JWTTokenDTO) => {
 const accessExpiration = Number(tokenData.expiration);
 if (!Number.isFinite(accessExpiration) || accessExpiration <= 0) {
  return DEFAULT_ACCESS_EXPIRATION_MINUTES;
 }
 return accessExpiration;
};

const getRefreshExpirationMinutes = (tokenData: JWTTokenDTO) => {
 const refreshExpirationRaw = (tokenData as any)?.refresh_expiration;
 const refreshExpiration = Number(refreshExpirationRaw);
 if (Number.isFinite(refreshExpiration) && refreshExpiration > 0) {
  return refreshExpiration;
 }
 return DEFAULT_REFRESH_EXPIRATION_MINUTES;
};

export const persistAuthTokens = (tokenData: JWTTokenDTO) => {
 if (!tokenData.access_token) {
  return;
 }

 const accessExpiration = getAccessExpirationMinutes(tokenData);
 const refreshExpiration = getRefreshExpirationMinutes(tokenData);
 const decoded = jwtDecode(tokenData.access_token);

 setCookieCustom('user', JSON.stringify(decoded), accessExpiration);
 setCookieCustom('access_token', tokenData.access_token, accessExpiration);
 setCookieCustom('expiration', accessExpiration.toString(), accessExpiration);
 setCookieCustom('user_id', (decoded as any)?.userId || '', accessExpiration);

 if (tokenData.refresh_token) {
  setCookieCustom('refresh_token', tokenData.refresh_token, refreshExpiration);
 }

 if (tokenData.configuration) {
  setConfigStorageItem({
   key: 'configuration',
   value: JSON.stringify(tokenData.configuration),
  });
 }
};

export const clearAuthTokens = () => {
 deleteCookieCustom('access_token', '/');
 deleteCookieCustom('refresh_token', '/');
 deleteCookieCustom('expiration', '/');
 deleteCookieCustom('user_id', '/');
 removeConfigStorageItem({ key: 'configuration' });
};

export const getAuthCookies = () => {
 return {
  accessToken: getCookieCustom('access_token'),
  refreshToken: getCookieCustom('refresh_token'),
 };
};
